// extracted by mini-css-extract-plugin
export default {"videoContainer":"BenefitsCMSPage_videoContainer__BwkhI","video":"BenefitsCMSPage_video__fjMhh","helperHeaderContainer":"BenefitsCMSPage_helperHeaderContainer__zO56c"};